import { fromJS } from 'immutable';

export default {
    setUsersManagers: (state, usersManagers) => {
        return state.setIn(['list'], fromJS(usersManagers)).set('initialized', true);
    },
    updateUsersManagers: (state, usersManagers) => {
        return state.mergeIn(['list'], fromJS(usersManagers));
    },
    updateUserManager: (state, userManagerId, userManager) => {
        return state.mergeIn(['list', userManagerId.toString()], fromJS(userManager));
    },
    setUserManager: (state, userManagerId) => {
        return state.deleteIn(['list', userManagerId.toString()]);
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/UsersManagers/core.js